import React from 'react';
import { Helmet } from 'react-helmet';

export const SEOHead = ({ seoData, productData, settings }) => {
  if (!seoData) return null;

  // Generate structured data for products
  const structuredData = productData && productData.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": productData[0].name,
    "description": productData[0].description,
    "brand": {
      "@type": "Brand",
      "name": seoData.business_name
    },
    "offers": {
      "@type": "Offer",
      "price": productData[0].price,
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock",
      "url": productData[0].buy_url
    }
  } : null;

  const gtmId = settings?.gtm_id;
  const faviconUrl = settings?.favicon_url;

  return (
    <Helmet>
      {/* Favicon */}
      {faviconUrl && (
        <link rel="icon" type="image/png" href={faviconUrl} />
      )}

      {/* Google Tag Manager */}
      {gtmId && (
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmId}');`}
        </script>
      )}

      {/* Basic SEO */}
      <title>{seoData.meta_title}</title>
      <meta name="description" content={seoData.meta_description} />
      <meta name="keywords" content={seoData.meta_keywords} />
      <meta name="robots" content={seoData.robots} />
      <link rel="canonical" href={seoData.canonical_url} />

      {/* Open Graph */}
      <meta property="og:title" content={seoData.og_title} />
      <meta property="og:description" content={seoData.og_description} />
      <meta property="og:type" content={seoData.og_type} />
      {seoData.og_image_url && (
        <meta property="og:image" content={seoData.og_image_url} />
      )}
      <meta property="og:url" content={seoData.canonical_url} />

      {/* Twitter Card */}
      <meta name="twitter:card" content={seoData.twitter_card} />
      <meta name="twitter:title" content={seoData.twitter_title} />
      <meta name="twitter:description" content={seoData.twitter_description} />
      {seoData.twitter_image_url && (
        <meta name="twitter:image" content={seoData.twitter_image_url} />
      )}

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};
